import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Heading, media } from '@higo/ui';
import { FormattedMessage } from 'react-intl';
import { CanceledInfo } from '../../ExaminationPageSection';

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 5rem 1fr;
  grid-column-gap: 1rem;
  align-items: center;

  ${media.mobile.max} {
    margin-left: 2.5rem;
    margin-bottom: 0;
    grid-template-columns: 4rem 1fr;
    grid-column-gap: 1rem;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled('span')(
  ({ theme }) => css`
    ${theme.typography.subtitle1}
    color: ${theme.palette.secondary['500']}
  `,
);

const MeasurementText = styled(Heading)(
  ({ theme }) => css`
    color: ${theme.palette.secondary['900']};
    white-space: nowrap;
    text-transform: uppercase;

    ${media.mobile.max} {
      font-size: 1rem;
    }
  `,
);

const BottomDivider = styled('div')(
  ({ theme }) => css`
    height: 1px;
    width: 100%;
    background-color: ${theme.palette.neutral['500']};
    margin-bottom: 1.5rem;

    ${media.mobile.max} {
      height: 0;
    }
  `,
);

interface MeasurementEntryProps {
  title: string;
  measurement: ReactNode;
  isVisitSection?: boolean;
  isCanceledStatus?: boolean;
}

export const MeasurementEntry: FC<MeasurementEntryProps> = ({
  title,
  measurement,
  children,
  isVisitSection = false,
  isCanceledStatus = false,
}) => {
  const fieldName = title.replace(/\s/g, '');

  return (
    <>
      <ContentContainer>
        <TextContainer>
          {!isVisitSection && (
            <Title id={`label-${fieldName}`}>
              <FormattedMessage id={title} />
            </Title>
          )}
          {!isCanceledStatus ? (
            <div id={`value-${fieldName}`}>
              <MeasurementText level={2}>{measurement}</MeasurementText>
            </div>
          ) : (
            <CanceledInfo>Canceled</CanceledInfo>
          )}
        </TextContainer>
        <div>{children}</div>
      </ContentContainer>
      {!isVisitSection && <BottomDivider />}
    </>
  );
};
